import moment, { ISO_8601 } from 'moment';
import React, { FC } from 'react';
import { HumanisedDate } from 'components/atoms/humanised-date';

export const DateView: FC<{ timestamp: string }> = ({ timestamp }) => (
  <HumanisedDate timestamp={moment(timestamp, ISO_8601)} />
);
